var _g, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewAr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "9.08 5 51.92 51.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_588_5601)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.041,
    cy: 30.9589,
    r: 25.9589,
    fill: "black",
    fillOpacity: 0.94,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0745 36.3477L32.2728 34.4079H28.07L27.2683 36.3477H25.1217L29.1563 27.2956H31.2253L35.2729 36.3477H33.0745ZM28.7425 32.8174H31.6133L30.1779 29.3517L28.7425 32.8174ZM44.4235 36.3477H42.1734L40.4277 33.826H40.3242H38.5009V36.3477H36.406V27.2956H40.3242C42.7424 27.2956 44.2554 28.55 44.2554 30.5802C44.2554 31.938 43.57 32.9337 42.3933 33.4381L44.4235 36.3477ZM42.1346 30.5802C42.1346 29.5845 41.4881 29.0026 40.2078 29.0026H38.5009V32.1579H40.2078C41.4881 32.1579 42.1346 31.563 42.1346 30.5802Z",
    fill: "#FFE227"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6694 24.9112V20.875H26.7057",
    stroke: "#FFE227",
    strokeWidth: 2.16776,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6694 38.8164V42.8526H26.7057",
    stroke: "#FFE227",
    strokeWidth: 2.16776,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3003 24.9102V20.8739H43.2641",
    stroke: "#FFE227",
    strokeWidth: 2.16776,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4092 38.5145V42.5508H43.3729",
    stroke: "#FFE227",
    strokeWidth: 2.16776,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_588_5601",
    x: 0.841104,
    y: 0.0554433,
    width: 68.3998,
    height: 68.3998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.29637
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.12046
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14902 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_588_5601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_588_5601",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAr);
export default __webpack_public_path__ + "static/media/view_ar.5aa23d583681216424fea457b60e75b8.svg";
export { ForwardRef as ReactComponent };